// extracted by mini-css-extract-plugin
export default {"main":"Signup_main__ctHTo","signup_card":"Signup_signup_card__64bRV"};